import { Component, OnDestroy, OnInit } from '@angular/core';
import { MapFitService } from '@ridango/core';

@Component({
    templateUrl: './explore-trip-details-page.component.html'
})
export class ExploreTripDetailsPageComponent implements OnInit, OnDestroy {
    constructor(private mapFitService: MapFitService) {}

    ngOnInit(): void {
        this.mapFitService.setFit(false);
    }
    ngOnDestroy(): void {
        this.mapFitService.setFit(true);
    }
}
